<template>
    <div id="map" class="map-container">
        <panel></panel>
        <div class="legend-container">
            <div class="legend" v-bind:class="{ 'legend-pressure': legend=='pressure','legend-puha': legend=='puha','legend-ehai': legend=='ehai' }"></div>
            <div class="legend-text-top">{{ legendTextTop }}</div>
            <div class="legend-text-bottom">{{ legendTextBottom }}</div>
        </div>
    </div>
</template>

<script>
  import "leaflet/dist/leaflet.css";
  import L from "leaflet";
  import panel from '@/components/risk/panel'

  export default {
    name: "risk",
    components: {
      panel
    },
    data(){
      return {
        map: null,
        layer1: null,
        caseMarker: [],
        panelHover: false,
        legend: '',
        legendTextTop: '',
        legendTextBottom: ''
      };
    },
    watch: {
        panelHover: function () {
            if(this.panelHover){
                document.getElementById('map').style.cursor='default';
                this.map.dragging.disable()
                this.map.scrollWheelZoom.disable();     
            }
            else{
                this.map.dragging.enable();
                this.map.scrollWheelZoom.enable();
                document.getElementById('map').style.cursor='grab';
            }
        },
    },
    mounted() {
        this.map = L.map("map").setView([38.959, 12.623], 6);
        L.tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}", {
        attribution:
            '&copy; <a href="https://www.ctninnova.com/en/">Centro Tecnológico Naval y del Mar</a>'
        }).addTo(this.map);

        L.tileLayer.wms('https://geoserver.ctnmapserver.dev/geoserver/QUIETMED2/wms', {
            layers: 'GridWestMEDSea',
            format: 'image/png',
            transparent: true,
            opacity: 0.3
        }).addTo(this.map);

    },
    beforeDestroy() {
        if (this.map) {
            this.map.remove()
        }
    },
    methods: {
        showLayer(mapType, specie, caseType){

            if(this.layer1 != null)
                this.map.removeLayer(this.layer1)
            
            if(this.caseMarker != null)
                this.caseMarker.forEach(Marker => {
                    this.map.removeLayer(Marker)
                });
            
            var layers_name = ''
            switch (mapType) {
                case 'pressure':
                    layers_name = mapType + '_' + caseType            
                    break;
                case 'puha':
                    layers_name = mapType + '_' + specie
                    break;
                case 'ehai':
                    layers_name = mapType + '_' + caseType + '_' + specie
                    break;
                case 'risk':
                    layers_name = mapType + '_' + caseType + '_' + specie
                    break;
            }

            this.legend = mapType
            this.legendText(mapType) 

            this.layer1 = L.tileLayer.wms('https://geoserver.ctnmapserver.dev/geoserver/QUIETMED2/wms', {
                layers: layers_name, 
                format: 'image/png',
                transparent: true,
                opacity: 0.8
            })
          
            this.layer1.addTo(this.map)

            switch (caseType) {
                case 'case1':
                    this.caseMarker.push(L.marker([43.504166667354, 7.391666667707]).addTo(this.map).bindPopup("PILE DRIVING  Monaco"));
                    this.caseMarker.push(L.marker([39.504166667034, 12.391666668107]).addTo(this.map).bindPopup("SONAR Tyrrhenian Sea"));
                    this.caseMarker.push(L.marker([36.704166666809996, -0.808333332949001]).addTo(this.map).bindPopup("SONAR Spain"));
                    this.caseMarker.push(L.marker([42.104166667242, 5.991666667594998]).addTo(this.map).bindPopup("AIRGUN France"));
                    this.caseMarker.push(L.marker([37.704166666889996, 9.991666667914998]).addTo(this.map).bindPopup("AIRGUN Tunisia"));
                    break;
                case 'case2':
                    this.caseMarker.push(L.marker([43.504166667354, 7.391666667707]).addTo(this.map).bindPopup("PILE DRIVING  Monaco"));
                    this.caseMarker.push(L.marker([36.704166666809996, -0.808333332949001]).addTo(this.map).bindPopup("SONAR Spain"));
                    this.caseMarker.push(L.marker([37.704166666889996, 9.991666667914998]).addTo(this.map).bindPopup("AIRGUN Tunisia"));
                    break;
                case 'case3':
                    this.caseMarker.push(L.marker([42.104166667242, 5.991666667594998]).addTo(this.map).bindPopup("AIRGUN France"));
                    this.caseMarker.push(L.marker([37.704166666889996, 9.991666667914998]).addTo(this.map).bindPopup("AIRGUN Tunisia"));
                    break;
                case 'case4':
                    this.caseMarker.push(L.marker([36.704166666809996, -0.808333332949001]).addTo(this.map).bindPopup("SONAR Spain"));
                    this.caseMarker.push(L.marker([42.104166667242, 5.991666667594998]).addTo(this.map).bindPopup("AIRGUN France"));
                    this.caseMarker.push(L.marker([37.704166666889996, 9.991666667914998]).addTo(this.map).bindPopup("AIRGUN Tunisia"));
                    break;
                case 'case5':
                    this.caseMarker.push(L.marker([37.704166666889996, 9.991666667914998]).addTo(this.map).bindPopup("AIRGUN Tunisia"));
                    break;
                
            }

                          
        },
        legendText(mapType){
            switch (mapType) {
                case 'pressure':
                    this.legendTextTop = '260 dB re 1uPa'            
                    this.legendTextBottom = '100 dB re 1uPa'            
                    break;
                case 'puha':
                    this.legendTextTop = '100%'            
                    this.legendTextBottom = '0%' 
                    break;
                case 'ehai':
                    this.legendTextTop = '100%'            
                    this.legendTextBottom = '0%'
                    break;
                default:
                    this.legendTextTop = ''            
                    this.legendTextBottom = '' 
                    break;
            }
        }
    }   
  }
</script>
<style scoped lang="scss">
    .map-container {
        width: 100%;
        position: absolute;
        bottom: 68px;
        top: 80px;
    }
    .legend-container {
        width: 300px;
        height: 200px;
        background-color: rgba(255,255,255,0.0);
        position: absolute;
        left: 12px;
        top: 100px;
        z-index: 1000;
    }
    .legend {
        width: 30px;
        height: 100px;
        position: absolute;
        left: 0px;
        top: 0px;
        border: 1px solid white;
        border-radius: 5px;
        opacity: 0;

        -webkit-transition: .25s ease-in-out;
        -moz-transition: .25s ease-in-out;
        -o-transition: .25s ease-in-out;
        transition: .25s ease-in-out;
    }
    .legend-pressure {
        opacity: 1;
        background: linear-gradient(0deg, rgba(255,234,0,1) 0%, rgba(255,0,0,1) 100%);
    }
    .legend-puha {
        opacity: 1;
        background: linear-gradient(0deg, rgba(121,235,164,1) 0%, rgba(237,166,63,1) 50%, rgba(250,12,12,1) 100%);
    }
    .legend-ehai {
        opacity: 1;
        background: linear-gradient(0deg, rgba(253,209,209,1) 0%, rgba(255,0,0,1) 100%);
    }
    .legend-text-top {
        position: absolute;
        left: 40px;
        top: 5px;
        color: white;
    }
    .legend-text-bottom {
        position: absolute;
        left: 40px;
        top: 78px;
        color: white;
    }
</style>